/**
 * Android: tasto/gesto Indietro di sistema. Ordine: chiude ciò che è aperto (menu, finestre, tendine, schermate a
 * tutto schermo) → torna alla pagina precedente → alla prima pagina esce dall'app (come ogni app Android).
 * Su iOS non serve (c'è il gesto sul bordo gestito da NativeScrollEffects).
 */
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

const ROOT = /^\/construction\/?(cruscotto|login)?\/?$/;

function closeTopLayer(): boolean {
  // tendine / finestre / fogli / menu laterale (Radix): Esc li chiude con la loro animazione
  if (document.querySelector('[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"], [data-radix-popper-content-wrapper]')) {
    document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", code: "Escape", keyCode: 27, bubbles: true }));
    return true;
  }
  // schermate a tutto schermo non Radix (ricerca dell'isola, nuovo rapportino…): il loro pulsante di chiusura
  const fs = document.querySelector<HTMLElement>("[data-kb-fit]");
  const close = fs?.querySelector<HTMLElement>('button[aria-label="Chiudi"], button[aria-label="Chiudi ricerca"]');
  if (close) {
    close.click();
    return true;
  }
  return false;
}

export function installBackButton() {
  if (Capacitor.getPlatform() !== "android") return;
  void App.addListener("backButton", () => {
    if (closeTopLayer()) return;
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0 && !ROOT.test(window.location.pathname)) window.history.back();
    else void App.exitApp();
  });
}
